import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withCtx as _withCtx, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center gap-3 rounded-xl border border-slate-200 bg-white px-6 py-16 shadow-sm"
};
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center gap-3 rounded-xl border border-rose-200 bg-white px-6 py-16 shadow-sm"
};
const _hoisted_4 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-rose-100"
};
const _hoisted_5 = {
  key: 2,
  class: "flex flex-col items-center gap-3 rounded-xl border border-slate-200 bg-white px-6 py-16 shadow-sm"
};
const _hoisted_6 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"
};
const _hoisted_7 = {
  key: 3,
  class: "rounded-xl border border-violet-200 bg-gradient-to-br from-violet-50 to-purple-50 px-5 py-6 shadow-sm sm:px-6"
};
const _hoisted_8 = {
  class: "flex flex-wrap items-center gap-3"
};
const _hoisted_9 = {
  class: "flex h-10 w-10 items-center justify-center rounded-full bg-violet-100"
};
const _hoisted_10 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_11 = {
  class: "mt-3 break-words text-sm text-slate-600"
};
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_13 = {
  key: 4,
  class: "pb-28"
};
const _hoisted_14 = {
  class: "rounded-xl border border-slate-200 bg-white shadow-sm"
};
const _hoisted_15 = {
  class: "flex flex-col gap-3 border-b border-slate-200 px-4 pt-2 sm:px-6"
};
const _hoisted_16 = {
  key: 0,
  class: "rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700"
};
const _hoisted_17 = {
  class: "flex flex-wrap items-center justify-between gap-2 pb-3"
};
const _hoisted_18 = {
  class: "text-sm text-slate-500"
};
const _hoisted_19 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_20 = {
  key: 0,
  class: "ml-0.5 rounded-full status-badge is-orange px-1.5 py-0.5 text-[11px] font-medium leading-4 ring-1 ring-orange-100"
};
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
  key: 2,
  class: "text-sm text-amber-700"
};
const _hoisted_23 = {
  key: 3,
  class: "text-sm text-slate-500"
};
const _hoisted_24 = {
  class: "space-y-6 px-4 py-4 sm:px-6"
};
const _hoisted_25 = {
  key: 0,
  class: "carryover-candidate-panel rounded-lg border border-slate-200 bg-slate-50/70 px-3 py-3 sm:px-4"
};
const _hoisted_26 = {
  class: "flex flex-col gap-3 md:flex-row md:items-center md:justify-between"
};
const _hoisted_27 = {
  class: "min-w-0"
};
const _hoisted_28 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_29 = {
  key: 0,
  class: "rounded-full status-badge is-warning px-2 py-0.5 text-xs font-medium ring-1 ring-amber-100"
};
const _hoisted_30 = ["disabled"];
const _hoisted_31 = {
  key: 0,
  class: "mt-2 flex items-center gap-2 rounded-md bg-white px-3 py-2 text-sm text-slate-500 ring-1 ring-slate-100"
};
const _hoisted_32 = {
  key: 1,
  class: "mt-2 flex items-center gap-2 rounded-md bg-white px-3 py-2 text-sm text-slate-500 ring-1 ring-slate-100"
};
const _hoisted_33 = {
  key: 2,
  class: "mt-3 divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-200 bg-white"
};
const _hoisted_34 = ["value", "disabled"];
const _hoisted_35 = {
  class: "min-w-0 flex-1"
};
const _hoisted_36 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_37 = {
  class: "min-w-0"
};
const _hoisted_38 = {
  class: "block break-words text-sm font-medium leading-5 text-slate-800"
};
const _hoisted_39 = {
  class: "mt-1 flex flex-wrap items-center gap-1.5 text-[11px] leading-5"
};
const _hoisted_40 = {
  key: 0,
  class: "rounded bg-slate-100 px-1.5 text-slate-500"
};
const _hoisted_41 = {
  key: 1,
  class: "rounded bg-blue-50 px-1.5 text-blue-600"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  key: 0,
  class: "mt-1 block break-words text-xs leading-5 text-slate-500"
};
const _hoisted_44 = {
  class: "mb-2.5 flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_45 = {
  key: 0,
  class: "flex flex-wrap gap-2"
};
const _hoisted_46 = {
  key: 0,
  class: "flex flex-col items-center gap-2 rounded-lg border border-dashed border-slate-300 px-4 py-10 text-center"
};
const _hoisted_47 = {
  key: 1,
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_48 = {
  class: "border-t border-slate-200 pt-5"
};
const _hoisted_49 = {
  class: "mb-3 flex items-center gap-2"
};
const _hoisted_50 = {
  class: "flex h-7 w-7 items-center justify-center rounded-lg bg-blue-50"
};
const _hoisted_51 = {
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_52 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_53 = ["readonly"];
const _hoisted_54 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_55 = ["readonly"];
const _hoisted_56 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_57 = ["readonly"];
const _hoisted_58 = {
  key: 0,
  class: "group relative flex flex-col overflow-hidden rounded-lg border border-amber-200 bg-amber-50/30 transition-all duration-200 cursor-text focus-within:border-amber-400 focus-within:ring-2 focus-within:ring-amber-100 md:col-span-2"
};
const _hoisted_59 = {
  class: "flex items-center gap-1.5 border-b border-amber-100 px-3 py-2"
};
const _hoisted_60 = {
  class: "mb-2.5 flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_61 = {
  key: 0,
  class: "mt-0.5 text-sm text-amber-700"
};
const _hoisted_62 = {
  key: 0,
  class: "flex flex-col items-center gap-2 rounded-lg border border-dashed border-slate-300 px-4 py-10 text-center"
};
const _hoisted_63 = {
  key: 1,
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_64 = {
  class: "border-t border-slate-200 pt-5"
};
const _hoisted_65 = {
  class: "mb-3 flex items-center gap-2"
};
const _hoisted_66 = {
  class: "flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-50"
};
const _hoisted_67 = {
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_68 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_69 = ["readonly"];
const _hoisted_70 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_71 = ["readonly"];
const _hoisted_72 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_73 = ["readonly"];
const _hoisted_74 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-2"
};
const _hoisted_75 = ["readonly"];
const _hoisted_76 = {
  key: 0,
  class: "group relative flex flex-col overflow-hidden rounded-lg border border-amber-200 bg-amber-50/30 transition-all duration-200 cursor-text focus-within:border-amber-400 focus-within:ring-2 focus-within:ring-amber-100 md:col-span-2"
};
const _hoisted_77 = {
  class: "flex items-center gap-1.5 border-b border-amber-100 px-3 py-2"
};
const _hoisted_78 = {
  class: "fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200/80 bg-white/90 px-4 py-3.5 shadow-[0_-4px_16px_rgba(0,0,0,0.06)] backdrop-blur-md sm:px-6 lg:left-64"
};
const _hoisted_79 = {
  class: "mx-auto flex max-w-7xl flex-wrap items-center justify-end gap-3"
};
const _hoisted_80 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_81 = ["disabled"];
const _hoisted_82 = ["disabled"];
const _hoisted_83 = ["disabled"];
const _hoisted_84 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-100 px-5 pb-4 pt-5"
};
const _hoisted_85 = {
  class: "min-w-0"
};
const _hoisted_86 = {
  class: "flex items-center gap-2.5"
};
const _hoisted_87 = {
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600"
};
const _hoisted_88 = ["disabled"];
const _hoisted_89 = {
  class: "space-y-4 px-5 py-5"
};
const _hoisted_90 = {
  class: "rounded-lg border border-slate-200 bg-white px-4 py-3"
};
const _hoisted_91 = {
  class: "flex flex-wrap items-center justify-between gap-2"
};
const _hoisted_92 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_93 = ["disabled", "onClick"];
const _hoisted_94 = {
  class: "mt-2 flex items-center gap-2"
};
const _hoisted_95 = ["max", "disabled"];
const _hoisted_96 = ["min", "disabled"];
const _hoisted_97 = {
  class: "flex items-center justify-between gap-3 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_98 = {
  class: "truncate text-xs text-slate-500"
};
const _hoisted_99 = {
  class: "flex shrink-0 gap-2"
};
const _hoisted_100 = ["disabled"];
const _hoisted_101 = ["disabled"];
const _hoisted_102 = {
  class: "px-5 pb-2 pt-5 text-center"
};
const _hoisted_103 = {
  class: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100"
};
const _hoisted_104 = {
  class: "flex justify-end gap-2 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_105 = {
  class: "space-y-4 px-5 py-4"
};
const _hoisted_106 = {
  class: "rounded-lg border border-slate-200 bg-slate-50/70 px-3 py-3"
};
const _hoisted_107 = {
  key: 0,
  class: "mt-2 flex flex-wrap gap-1.5"
};
const _hoisted_108 = {
  class: "truncate"
};
const _hoisted_109 = {
  key: 1,
  class: "mt-2 text-xs text-slate-400"
};
const _hoisted_110 = {
  class: "grid gap-3 md:grid-cols-2"
};
const _hoisted_111 = {
  class: "block min-w-0"
};
const _hoisted_112 = {
  class: "block min-w-0"
};
const _hoisted_113 = {
  class: "flex justify-end gap-2 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_114 = ["disabled"];
const _hoisted_115 = ["disabled"];
const _hoisted_116 = {
  class: "flex shrink-0 items-start justify-between gap-4 border-b border-slate-100 px-5 pb-4 pt-5"
};
const _hoisted_117 = {
  class: "min-w-0"
};
const _hoisted_118 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_119 = {
  key: 0,
  class: "status-badge is-orange"
};
const _hoisted_120 = {
  class: "min-h-0 flex-1 overflow-y-auto px-5 py-5"
};
const _hoisted_121 = {
  class: "flex shrink-0 items-start justify-between gap-4 border-b border-slate-100 px-5 pb-4 pt-5"
};
const _hoisted_122 = {
  class: "min-w-0"
};
const _hoisted_123 = {
  class: "mt-1 truncate text-sm text-slate-500"
};
const _hoisted_124 = {
  class: "min-h-0 flex-1 overflow-y-auto px-5 py-4"
};
const _hoisted_125 = {
  key: 0,
  class: "flex items-center justify-center gap-2 py-12 text-sm text-slate-500"
};
const _hoisted_126 = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-12 text-center"
};
const _hoisted_127 = {
  key: 2,
  class: "rounded-lg border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-400"
};
const _hoisted_128 = {
  key: 3,
  class: "space-y-3"
};
const _hoisted_129 = {
  class: "flex flex-wrap items-center justify-between gap-2 text-xs text-slate-400"
};
const _hoisted_130 = {
  class: "font-medium text-slate-600"
};
const _hoisted_131 = {
  class: "mt-1.5 whitespace-pre-wrap break-words text-sm leading-6 text-slate-700"
};
const _hoisted_132 = {
  key: 0,
  class: "shrink-0 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_133 = {
  class: "block"
};
const _hoisted_134 = {
  class: "mt-3 flex justify-end gap-2"
};
const _hoisted_135 = ["disabled"];
const _hoisted_136 = ["disabled"];
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { onBeforeRouteLeave, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { ArrowDownTrayIcon, BellIcon, ChatBubbleLeftRightIcon, CheckBadgeIcon, ClipboardDocumentCheckIcon, ClipboardDocumentListIcon, DocumentTextIcon, ExclamationTriangleIcon, HandRaisedIcon, InformationCircleIcon, PencilSquareIcon, PlusIcon, ShieldCheckIcon, StarIcon, UserGroupIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import ListPageShell from '@/components/ListPageShell.vue';
import AppModal from '@/components/AppModal.vue';
import DeleteConfirmModal from '@/components/DeleteConfirmModal.vue';
import { formatDateTimeText } from '@/utils/dateFormat';
import { getDailyWorkReport, addWorkItemTodoAnnotation, commentWorkReport, exportSelfWorkReports, getPlanEditOptions, getReportRecipientPreferences, getSelfWorkReportReminderSetting, listWorkItemTodoAnnotations, savePlanDraft, saveSelfWorkReportReminderSetting, saveSummaryDraft, submitPlan, submitSummary } from '@/api/workReport';
import { downloadBlob, resolveBlobErrorMessage } from '@/utils/download';
import { createClientRequestId, getReportOptimisticVersion, normalizeReportTodoSnapshot, normalizeTodoStatusCode } from './workReportUtils';
import { useWorkReportDraft } from './composables/useWorkReportDraft';
import { canAdjustPlan as canAdjustPlanForReport, canEditSummary as canEditSummaryForState, canSaveSummary as canSaveSummaryForState, canStartPlanAdjustment as canStartPlanAdjustmentForState, canSubmitSummary as canSubmitSummaryForState, createWorkReportSubmittedEditStateMachine } from './composables/workReportSubmittedEditStateMachine.mjs';
import UserSelector from '@/components/UserSelector/index.vue';
import ReportAttachmentList from './components/ReportAttachmentList.vue';
import ReportFeedbackSection from './components/ReportFeedbackSection.vue';
import ReportHeader from './components/ReportHeader.vue';
import WorkReportReminderSettingModal from './components/WorkReportReminderSettingModal.vue';
import ReportStageTabs from './components/ReportStageTabs.vue';
import ReportStatusBadge from './components/ReportStatusBadge.vue';
import ReportWorkItemEditor from './components/ReportWorkItemEditor.vue';
import TodoPickerDrawer from './components/TodoPickerDrawer.vue';
const MAX_EXPORT_RANGE_DAYS = 92;
export default {
  __name: 'MyWorkReport',
  setup(__props) {
    const route = useRoute();
    const report = ref(null);
    const reportDate = ref(normalizeReportDateQuery(route.query.reportDate) || localDate());
    const activePhase = ref(normalizeReportPhaseQuery(route.query.phase));
    const loading = ref(false);
    const loadError = ref(false);
    const submitting = ref(false);
    const recipientPreferencesLoading = ref(false);
    const feedbackSubmitting = ref(false);
    const reminderSettingVisible = ref(false);
    const reminderSettingLoading = ref(false);
    const reminderSettingSaving = ref(false);
    const reminderSetting = ref({});
    // 导出我的日报：默认区间跟随当前日报日期（单日），弹窗内可调整
    const EXPORT_RANGE_PRESETS = [{
      label: '今天',
      days: 0
    }, {
      label: '近7天',
      days: 6
    }, {
      label: '近30天',
      days: 29
    }];
    const showExportModal = ref(false);
    const exporting = ref(false);
    const exportRange = ref({
      startDate: '',
      endDate: ''
    });
    const exportRangeDays = computed(() => {
      const {
        startDate,
        endDate
      } = exportRange.value;
      if (!startDate || !endDate || startDate > endDate) return 0;
      return Math.round((new Date(endDate) - new Date(startDate)) / 86400000) + 1;
    });
    const exportSummaryText = computed(() => exportRangeDays.value > 0 ? `将导出 ${exportRangeDays.value} 天的日报` : '请选择有效的日期区间');
    const showTodoPicker = ref(false);
    const showFeedbackModal = ref(false);
    const feedbackFocusCommentId = ref(normalizeRouteId(route.query.commentId));
    const feedbackFocusTarget = ref(isTruthyRouteFlag(route.query.evaluation) ? 'evaluation' : feedbackFocusCommentId.value ? 'comments' : '');
    const attachments = ref([]);
    const planSubmitRecipientUsers = ref([]);
    const planSubmitCcUsers = ref([]);
    const adjustmentReason = ref('');
    const supplementReason = ref('');
    const planAdjustmentMode = ref(false);
    const summarySupplementMode = ref(false);
    const planSubmittedEditDirty = ref(false);
    const summarySubmittedEditDirty = ref(false);
    const planItemErrors = ref({});
    const planEditOptionsLoading = ref(false);
    const carryoverCandidates = ref([]);
    const selectedCarryoverCandidateKeys = ref([]);
    const workItemAnnotationCounts = ref({});
    const showTodoAnnotationModal = ref(false);
    const todoAnnotationLoading = ref(false);
    const todoAnnotationSubmitting = ref(false);
    const todoAnnotationError = ref(false);
    const todoAnnotationWorkItem = ref(null);
    const todoAnnotations = ref([]);
    const todoAnnotationContent = ref('');
    const showUnsavedModal = ref(false);
    const showPlanSubmitRecipientsModal = ref(false);
    let unsavedChoiceResolver = null;
    let loadRequestToken = 0;
    const planDraft = useWorkReportDraft({
      report,
      phase: 'plan',
      save: payload => savePlanDraft(report.value.id, payload),
      resync: () => resyncReportVersion(),
      onConflict: () => ElMessage.error('计划草稿存在版本冲突，请重新加载后再编辑')
    });
    const summaryDraft = useWorkReportDraft({
      report,
      phase: 'summary',
      save: payload => saveSummaryDraft(report.value.id, payload),
      resync: () => resyncReportVersion(),
      onConflict: () => ElMessage.error('总结草稿存在版本冲突，请重新加载后再编辑')
    });
    const submittedEditState = createWorkReportSubmittedEditStateMachine();
    const workItems = computed(() => report.value?.workItems || []);
    const fixedReportRecipients = computed(() => (report.value?.recipients || []).filter(recipient => !isEditableReportRecipient(recipient)));
    const fixedRecipientUserIds = computed(() => selectorUserIds(fixedReportRecipients.value));
    const planSubmitRecipientExcludeIds = computed(() => [...fixedRecipientUserIds.value, ...selectorUserIds(planSubmitCcUsers.value)]);
    const planSubmitCcExcludeIds = computed(() => [...fixedRecipientUserIds.value, ...selectorUserIds(planSubmitRecipientUsers.value)]);
    const selectedTodoIds = computed(() => workItems.value.map(item => item.todoId).filter(Boolean));
    const existingCarryoverSourceIds = computed(() => new Set(workItems.value.map(item => item.carryoverFromWorkItemId).filter(Boolean).map(String)));
    const displayedCarryoverCandidates = computed(() => carryoverCandidates.value.filter(candidate => !isCarryoverCandidateAdded(candidate)));
    const selectedCarryoverCandidates = computed(() => {
      const selectedKeys = new Set(selectedCarryoverCandidateKeys.value.map(String));
      return displayedCarryoverCandidates.value.filter(candidate => selectedKeys.has(candidate.candidateKey));
    });
    const carryoverCandidateTotalCount = computed(() => displayedCarryoverCandidates.value.length);
    const selectedCarryoverCandidateCount = computed(() => selectedCarryoverCandidates.value.length);
    const hasReportablePlanItem = computed(() => workItems.value.some(item => isReportablePlanItem(item)));
    const canAddTodoAnnotation = computed(() => Boolean(!isIneligible.value && !isFutureReportDate.value && report.value?.id && todoAnnotationWorkItem.value?.id && todoAnnotationWorkItem.value?.todoId && todoAnnotationWritable(todoAnnotationWorkItem.value)));
    const isIneligible = computed(() => ['AUTO_EXEMPT', 'MANUAL_EXEMPT', 'PENDING_STATUS_CONFIRMATION'].includes(report.value?.eligibilityStatus));
    const eligibilitySource = computed(() => report.value?.eligibilitySource || report.value?.exemptionSource || '');
    const isFutureReportDate = computed(() => isReportDateAfterToday(report.value?.reportDate || reportDate.value));
    const canAdjustPlan = computed(() => canAdjustPlanForReport(report.value));
    const canStartPlanAdjustment = computed(() => canStartPlanAdjustmentForState({
      summaryHasUnsavedChanges: summaryDraft.hasUnsavedChanges.value,
      summarySaveStatus: summaryDraft.saveStatus.value
    }));
    const recipientEditable = computed(() => !isIneligible.value && !isFutureReportDate.value && Boolean(report.value?.id));
    const planEditable = computed(() => !isIneligible.value && !isFutureReportDate.value && (report.value?.planStatus !== 'SUBMITTED' || canAdjustPlan.value && planAdjustmentMode.value));
    const planSubmitted = computed(() => report.value?.planStatus === 'SUBMITTED');
    const summaryNeedsSupplement = computed(() => reportSupplementRequested(report.value));
    const canEditSummary = computed(() => canEditSummaryForState({
      planStatus: report.value?.planStatus,
      planSubmittedEditDirty: planSubmittedEditDirty.value
    }));
    const canSaveSummary = computed(() => canSaveSummaryForState({
      planStatus: report.value?.planStatus,
      planSubmittedEditDirty: planSubmittedEditDirty.value
    }));
    const summaryEditable = computed(() => canEditSummary.value && !isIneligible.value && !isFutureReportDate.value && (report.value?.summaryStatus !== 'SUBMITTED' || summarySupplementMode.value || summaryNeedsSupplement.value));
    const isSubmittedPlanEdit = computed(() => planAdjustmentMode.value && canAdjustPlan.value);
    const isSubmittedSummaryEdit = computed(() => summarySupplementMode.value && report.value?.summaryStatus === 'SUBMITTED');
    const isSubmittedPhaseEdit = computed(() => activePhase.value === 'plan' ? isSubmittedPlanEdit.value : isSubmittedSummaryEdit.value);
    const activeEditable = computed(() => activePhase.value === 'plan' ? planEditable.value : summaryEditable.value);
    const activeDraft = computed(() => activePhase.value === 'plan' ? planDraft : summaryDraft);
    const attachmentMaxSizeMb = computed(() => {
      const bytes = Number(report.value?.attachmentMaxSizeBytes);
      return Number.isFinite(bytes) && bytes > 0 ? Math.ceil(bytes / 1024 / 1024) : 20;
    });
    const canSubmitSummary = computed(() => canSubmitSummaryForState({
      planStatus: report.value?.planStatus,
      planSubmittedEditDirty: planSubmittedEditDirty.value
    }));
    const summaryBlockedReason = computed(() => {
      if (isIneligible.value) return '';
      if (!planSubmitted.value) return '请先提交计划后再填写总结';
      if (!canEditSummary.value) return '请先提交或放弃计划调整';
      return '';
    });
    const summaryDescription = computed(() => summaryBlockedReason.value || '填写今天的工作结果。');
    const hasSubmittedEditChanges = computed(() => planSubmittedEditDirty.value || summarySubmittedEditDirty.value);
    const activeDraftStatus = computed(() => hasSubmittedEditChanges.value ? 'dirty' : activeDraft.value.saveStatus.value);
    const hasUnsavedChanges = computed(() => planDraft.hasUnsavedChanges.value || summaryDraft.hasUnsavedChanges.value || planSubmittedEditDirty.value || summarySubmittedEditDirty.value);
    const feedbackCommentCount = computed(() => Array.isArray(report.value?.comments) ? report.value.comments.length : 0);
    const hasCurrentSummaryEvaluation = computed(() => Array.isArray(report.value?.evaluations) && report.value.evaluations.some(evaluation => evaluation?.current && evaluation?.phase === 'SUMMARY'));
    const feedbackButtonLabel = computed(() => {
      if (summaryNeedsSupplement.value) return '查看反馈';
      if (hasCurrentSummaryEvaluation.value) return '查看评价';
      if (feedbackCommentCount.value > 0) return '查看评论';
      return '评价与反馈';
    });
    const feedbackBadgeLabel = computed(() => {
      if (summaryNeedsSupplement.value) return '待补充';
      if (feedbackCommentCount.value > 0) return `${feedbackCommentCount.value}条`;
      if (hasCurrentSummaryEvaluation.value) return '已评价';
      return '';
    });
    watch(activePhase, () => {
      if (activePhase.value === 'summary' && summaryNeedsSupplement.value) summarySupplementMode.value = true;
    });
    watch(() => [route.query.reportDate, route.query.phase, route.query.feedback, route.query.commentId, route.query.evaluation], async () => {
      const nextPhase = normalizeReportPhaseQuery(route.query.phase);
      if (activePhase.value !== nextPhase) activePhase.value = nextPhase;
      const nextDate = normalizeReportDateQuery(route.query.reportDate);
      let dateChanged = false;
      if (nextDate && nextDate !== reportDate.value) {
        await changeReportDate(nextDate);
        dateChanged = true;
      }
      if (!dateChanged) applyFeedbackRouteQuery();
    });
    onMounted(() => loadReport(reportDate.value));
    onMounted(() => {
      window.addEventListener('beforeunload', handleBeforeUnload);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    });
    onBeforeRouteLeave(async () => {
      if (!hasUnsavedChanges.value) return true;
      const choice = await requestUnsavedChoice();
      if (choice === 'continue') return false;
      if (choice === 'discard') {
        discardAllDrafts();
        return true;
      }
      try {
        await flushAllDrafts();
        return true;
      } catch {
        return false;
      }
    });
    function handleBeforeUnload(event) {
      if (!hasUnsavedChanges.value) return;
      event.preventDefault();
      event.returnValue = '';
    }
    async function loadReport(date) {
      const requestToken = ++loadRequestToken;
      loading.value = true;
      loadError.value = false;
      try {
        const data = await getDailyWorkReport(date);
        if (requestToken !== loadRequestToken) return;
        report.value = data || null;
        attachments.value = Array.isArray(data?.attachments) ? data.attachments : [];
        adjustmentReason.value = '';
        supplementReason.value = '';
        planAdjustmentMode.value = false;
        showPlanSubmitRecipientsModal.value = false;
        showFeedbackModal.value = false;
        closeTodoAnnotationModal();
        resetPlanEditOptions();
        summarySupplementMode.value = Boolean(reportSupplementRequested(data));
        resetSubmittedEditDirty();
        planItemErrors.value = {};
        if (report.value?.id) await loadPlanEditOptions(report.value.id);
        applyFeedbackRouteQuery();
      } catch {
        if (requestToken !== loadRequestToken) return;
        report.value = null;
        loadError.value = true;
      } finally {
        if (requestToken === loadRequestToken) loading.value = false;
      }
    }
    async function loadPlanEditOptions(reportId) {
      planEditOptionsLoading.value = true;
      try {
        const options = await getPlanEditOptions(reportId);
        const candidates = normalizeCollection(options?.carryoverCandidates).map(normalizeCarryoverCandidate).filter(Boolean);
        carryoverCandidates.value = candidates;
        selectedCarryoverCandidateKeys.value = candidates.filter(candidate => !isCarryoverCandidateAdded(candidate)).map(candidate => candidate.candidateKey);
        syncWorkItemAnnotationCounts(options?.currentWorkItems);
      } catch {
        ElMessage.warning('未完成计划候选加载失败，可稍后重试');
      } finally {
        planEditOptionsLoading.value = false;
      }
    }
    function resetPlanEditOptions() {
      planEditOptionsLoading.value = false;
      carryoverCandidates.value = [];
      selectedCarryoverCandidateKeys.value = [];
      workItemAnnotationCounts.value = {};
    }
    function normalizeCollection(value) {
      if (Array.isArray(value)) return value;
      return value?.records || value?.list || value?.rows || value?.data || [];
    }
    function normalizeCarryoverCandidate(candidate) {
      if (!candidate || typeof candidate !== 'object') return null;
      const todoSnapshot = normalizeReportTodoSnapshot(candidate.todoSnapshot || candidate.currentTodoSnapshot || candidate);
      const todoId = candidate.todoId ?? todoSnapshot?.todoId;
      const sourceWorkItemId = candidate.sourceWorkItemId ?? candidate.workItemId ?? candidate.carryoverFromWorkItemId ?? candidate.id;
      if (!todoId || !sourceWorkItemId) return null;
      const annotations = normalizeCollection(candidate.annotations || candidate.todoAnnotations || candidate.recentAnnotations);
      const annotationCount = Number(candidate.annotationCount ?? candidate.todoAnnotationCount ?? todoSnapshot?.annotationCount ?? annotations.length);
      return {
        ...candidate,
        candidateKey: `carryover-${sourceWorkItemId}`,
        sourceWorkItemId,
        todoId,
        title: candidate.title || candidate.todayGoal || todoSnapshot?.title || '',
        todayGoal: todoDescriptionGoal(todoSnapshot, candidate),
        expectedOutcome: candidate.expectedOutcome || '',
        expectedFinishAt: candidate.expectedFinishAt || todoSnapshot?.dueDate || candidate.dueDate || '',
        reportDate: candidate.reportDate || candidate.sourceReportDate || candidate.planReportDate || '',
        annotations,
        annotationCount: Number.isFinite(annotationCount) ? annotationCount : annotations.length,
        todoSnapshot: todoSnapshot || normalizeReportTodoSnapshot({
          todoId,
          title: candidate.title || candidate.todayGoal,
          description: candidate.description,
          priority: candidate.priority,
          dueDate: candidate.dueDate,
          status: candidate.status,
          completeTime: candidate.completeTime,
          updateTime: candidate.updateTime,
          annotationCount: candidate.annotationCount ?? candidate.todoAnnotationCount ?? annotations.length
        })
      };
    }
    function hasCarryoverCandidateAnnotations(candidate) {
      const count = Number(candidate?.annotationCount);
      return Number.isFinite(count) && count > 0 || normalizeCollection(candidate?.annotations || candidate?.todoAnnotations).length > 0;
    }
    function syncWorkItemAnnotationCounts(items) {
      const next = {
        ...workItemAnnotationCounts.value
      };
      normalizeCollection(items).forEach(item => {
        const key = item?.id;
        if (!key) return;
        const annotations = normalizeCollection(item.annotations || item.todoAnnotations);
        const count = Number(item.annotationCount ?? item.todoAnnotationCount ?? item.currentTodoSnapshot?.annotationCount ?? item.todoSnapshot?.annotationCount ?? annotations.length);
        next[String(key)] = Number.isFinite(count) ? count : annotations.length;
      });
      workItemAnnotationCounts.value = next;
    }
    function isCarryoverCandidateAdded(candidate) {
      if (!candidate) return true;
      if (candidate.sourceWorkItemId && existingCarryoverSourceIds.value.has(String(candidate.sourceWorkItemId))) return true;
      if (candidate.todoId && selectedTodoIds.value.map(String).includes(String(candidate.todoId))) return true;
      return false;
    }
    async function changeReportDate(nextDate) {
      if (!nextDate || nextDate === reportDate.value) return;
      if (hasUnsavedChanges.value) {
        const choice = await requestUnsavedChoice();
        if (choice === 'continue') return;
        if (choice === 'discard') discardAllDrafts();
        if (choice === 'save') {
          try {
            await flushAllDrafts();
          } catch {
            return;
          }
        }
      }
      reportDate.value = nextDate;
      await loadReport(nextDate);
    }
    function ensureReportDateReached() {
      if (!isFutureReportDate.value) return true;
      ElMessage.warning('未到日期不能填写、保存或提交日报内容');
      return false;
    }
    function todoDescriptionGoal(snapshot, todo = {}) {
      return snapshot?.description || todo?.description || snapshot?.title || todo?.title || '';
    }
    function markPlanDirty() {
      if (!planEditable.value || !report.value) return;
      if (isSubmittedPlanEdit.value) {
        markSubmittedEditDirty('plan');
        return;
      }
      planDraft.markDirty(buildPlanPayload());
    }
    function markSummaryDirty() {
      if (!summaryEditable.value || !report.value) return;
      if (isSubmittedSummaryEdit.value) {
        markSubmittedEditDirty('summary');
        return;
      }
      summaryDraft.markDirty(buildSummaryPayload());
    }
    function updateWorkItem(index, item) {
      const previous = report.value.workItems[index];
      report.value.workItems.splice(index, 1, item);
      if (activePhase.value === 'plan') {
        clearPlanItemError(previous);
        clearPlanItemError(item);
        markPlanDirty();
      } else markSummaryDirty();
    }
    function removeWorkItem(index) {
      const item = report.value.workItems[index];
      report.value.workItems.splice(index, 1);
      if (activePhase.value === 'plan') {
        clearPlanItemError(item);
        markPlanDirty();
      } else markSummaryDirty();
    }
    const pendingRemoveIndex = ref(null);
    const pendingRemoveItem = computed(() => pendingRemoveIndex.value === null ? null : workItems.value[pendingRemoveIndex.value] || null);
    const pendingRemoveMessage = computed(() => {
      const title = pendingRemoveItem.value?.title || '未命名工作项';
      return `工作项「${title}」将被移除，保存后生效。`;
    });
    function requestRemoveWorkItem(index) {
      pendingRemoveIndex.value = index;
    }
    function cancelRemoveWorkItem() {
      pendingRemoveIndex.value = null;
    }
    function confirmRemoveWorkItem() {
      if (pendingRemoveIndex.value === null) return;
      removeWorkItem(pendingRemoveIndex.value);
      pendingRemoveIndex.value = null;
    }
    function addTodos(todos) {
      const existingIds = new Set(selectedTodoIds.value);
      const todoSnapshots = todos.map(todo => ({
        todo,
        snapshot: normalizeReportTodoSnapshot(todo)
      }));
      const skippedUnavailableCount = todoSnapshots.filter(({
        snapshot
      }) => snapshot?.todoId && !isPlanTodoReportable(snapshot)).length;
      const additions = todoSnapshots.filter(({
        snapshot
      }) => snapshot?.todoId && isPlanTodoReportable(snapshot) && !existingIds.has(snapshot.todoId)).map(({
        todo,
        snapshot
      }) => ({
        clientKey: createClientRequestId(),
        source: 'TODO',
        todoId: snapshot.todoId,
        title: snapshot.title || todo.title,
        todayGoal: todoDescriptionGoal(snapshot, todo),
        expectedFinishAt: snapshot.dueDate,
        todoAnnotationCount: snapshot.annotationCount,
        todoSnapshot: snapshot
      }));
      if (skippedUnavailableCount > 0) {
        ElMessage.warning('部分待办已完成或取消，已跳过，请刷新后重新选择');
      }
      if (!additions.length) return;
      report.value.workItems = [...workItems.value, ...additions];
      markPlanDirty();
    }
    function addSelectedCarryoverCandidates() {
      const existingTodoIds = new Set(selectedTodoIds.value.map(String));
      const selectedCandidates = selectedCarryoverCandidates.value.filter(candidate => candidate.todoId && candidate.sourceWorkItemId && !existingTodoIds.has(String(candidate.todoId)));
      const skippedUnavailableCount = selectedCandidates.filter(candidate => !isPlanTodoReportable(candidate)).length;
      const additions = selectedCandidates.filter(isPlanTodoReportable).map(candidate => ({
        clientKey: createClientRequestId(),
        source: 'CARRYOVER',
        todoId: candidate.todoId,
        carryoverFromWorkItemId: candidate.sourceWorkItemId,
        title: candidate.title || candidate.todoSnapshot?.title || '',
        todayGoal: todoDescriptionGoal(candidate.todoSnapshot, candidate),
        expectedOutcome: candidate.expectedOutcome || '',
        expectedFinishAt: candidate.expectedFinishAt || candidate.todoSnapshot?.dueDate || '',
        todoAnnotationCount: candidate.annotationCount ?? candidate.todoSnapshot?.annotationCount,
        todoSnapshot: candidate.todoSnapshot
      }));
      if (skippedUnavailableCount > 0) {
        ElMessage.warning('部分候选待办已完成或取消，已跳过，请刷新后重新选择');
      }
      if (!additions.length) {
        ElMessage.warning('请选择可加入的未完成计划');
        return;
      }
      report.value.workItems = [...workItems.value, ...additions];
      selectedCarryoverCandidateKeys.value = selectedCarryoverCandidateKeys.value.filter(key => !additions.some(item => `carryover-${item.carryoverFromWorkItemId}` === key));
      markPlanDirty();
    }
    function updateAttachments(nextAttachments) {
      attachments.value = nextAttachments;
      if (activePhase.value === 'plan') markPlanDirty();else markSummaryDirty();
    }
    async function saveActiveDraft() {
      if (!ensureReportDateReached()) return;
      if (isSubmittedPhaseEdit.value) return;
      if (activePhase.value === 'summary' && !canSaveSummary.value) {
        ElMessage.warning(summaryBlockedReason.value || '当前不能保存总结草稿');
        return;
      }
      try {
        if (activePhase.value === 'plan') {
          markPlanDirty();
          await planDraft.flush();
        } else {
          markSummaryDirty();
          await summaryDraft.flush();
        }
      } catch {
        ElMessage.error('草稿保存失败，请重试');
      }
    }
    async function retryActiveDraft() {
      try {
        await activeDraft.value.retry();
      } catch {
        ElMessage.error('草稿保存失败，请重试');
      }
    }
    async function submitActivePhase() {
      if (!ensureReportDateReached()) return;
      if (activePhase.value === 'plan') {
        await openPlanSubmitRecipientsModal();
        return;
      }
      await submitSummaryPhase();
    }
    async function openPlanSubmitRecipientsModal() {
      if (planAdjustmentMode.value && !canAdjustPlan.value) {
        ElMessage.warning('总结已提交后，计划调整不可用');
        return;
      }
      if (!validatePlan() || recipientPreferencesLoading.value || submitting.value) return;
      const targetReportId = report.value?.id;
      recipientPreferencesLoading.value = true;
      try {
        const preferences = await getReportRecipientPreferences();
        if (report.value?.id !== targetReportId) return;
        syncPlanSubmitRecipients(Array.isArray(preferences) ? preferences : []);
      } catch {
        if (report.value?.id !== targetReportId) return;
        syncPlanSubmitRecipientsFromReport(report.value);
        ElMessage.warning('默认报送对象加载失败，请确认后提交');
      } finally {
        recipientPreferencesLoading.value = false;
      }
      if (report.value?.id === targetReportId) {
        showPlanSubmitRecipientsModal.value = true;
      }
    }
    function cancelPlanSubmission() {
      if (submitting.value) return;
      showPlanSubmitRecipientsModal.value = false;
    }
    async function confirmPlanSubmission() {
      if (submitting.value) return;
      submitting.value = true;
      try {
        planDraft.cancelAutoSave();
        const updated = await submitPlan(report.value.id, buildPlanPayload({
          expectedVersion: getReportOptimisticVersion(report.value),
          clientRequestId: createClientRequestId(),
          recipients: buildEditableRecipientsPayload()
        }));
        report.value = updated;
        if (report.value?.id) await loadPlanEditOptions(report.value.id);
        planDraft.discard();
        showPlanSubmitRecipientsModal.value = false;
        planAdjustmentMode.value = false;
        clearSubmittedEditDirty('plan');
        ElMessage.success('计划已提交');
      } catch {
        ElMessage.error('提交失败，请检查网络后重试');
      } finally {
        submitting.value = false;
      }
    }
    async function submitSummaryPhase() {
      if (!canSubmitSummary.value) {
        ElMessage.warning(summaryBlockedReason.value || '当前不能提交总结');
        return;
      }
      if (!validateSummary()) return;
      submitting.value = true;
      try {
        if (!isSubmittedSummaryEdit.value) {
          markSummaryDirty();
          await summaryDraft.flush();
        }
        const updated = await submitSummary(report.value.id, buildSummaryPayload({
          expectedVersion: getReportOptimisticVersion(report.value),
          clientRequestId: createClientRequestId()
        }));
        report.value = updated;
        summarySupplementMode.value = false;
        clearSubmittedEditDirty('summary');
        ElMessage.success('总结已提交');
      } catch {
        ElMessage.error('提交失败，请检查网络后重试');
      } finally {
        submitting.value = false;
      }
    }
    async function submitSelfComment(comment) {
      if (!report.value?.id || !comment?.content) return;
      feedbackSubmitting.value = true;
      try {
        await commentWorkReport(report.value.id, {
          parentCommentId: comment.parentCommentId || null,
          content: comment.content,
          clientRequestId: createClientRequestId()
        });
        ElMessage.success('评论已提交');
        await refreshReportFeedback();
      } catch {
        ElMessage.error('评论提交失败，请稍后重试');
      } finally {
        feedbackSubmitting.value = false;
      }
    }
    function workItemAnnotationCount(item) {
      if (!item?.id) return 0;
      const cached = workItemAnnotationCounts.value[String(item.id)];
      if (Number.isFinite(Number(cached))) return Number(cached);
      const snapshotCount = Number(item.todoAnnotationCount ?? item.currentTodoSnapshot?.annotationCount ?? item.todoSnapshot?.annotationCount);
      if (Number.isFinite(snapshotCount)) return snapshotCount;
      const annotations = normalizeCollection(item.annotations || item.todoAnnotations);
      const count = Number(item.annotationCount ?? item.todoAnnotationCount ?? annotations.length);
      return Number.isFinite(count) ? count : annotations.length;
    }
    function syncWorkItemAnnotationSummary(item, annotations) {
      if (!item?.id) return;
      const list = normalizeCollection(annotations);
      const latest = latestTodoAnnotation(list);
      const patch = {
        todoAnnotationCount: list.length,
        todoLatestAnnotationContent: latest?.content || '',
        todoLatestAnnotationTime: latest?.createTime || '',
        todoLatestAnnotationCreatorName: latest?.creatorName || ''
      };
      Object.assign(item, patch);
      const key = itemKey(item);
      const index = workItems.value.findIndex(workItem => itemKey(workItem) === key);
      if (index >= 0) {
        Object.assign(workItems.value[index], patch);
      }
      workItemAnnotationCounts.value = {
        ...workItemAnnotationCounts.value,
        [String(item.id)]: list.length
      };
    }
    function latestTodoAnnotation(annotations) {
      return [...normalizeCollection(annotations)].filter(annotation => annotation?.content).sort(compareTodoAnnotations).at(-1) || null;
    }
    function compareTodoAnnotations(left, right) {
      const timeDiff = annotationTimeValue(left?.createTime) - annotationTimeValue(right?.createTime);
      if (timeDiff !== 0) return timeDiff;
      return numericId(left?.id) - numericId(right?.id);
    }
    function annotationTimeValue(value) {
      const text = String(value || '').trim();
      if (!text) return 0;
      const normalized = text.includes('T') ? text : text.replace(' ', 'T');
      const timestamp = Date.parse(normalized);
      return Number.isFinite(timestamp) ? timestamp : 0;
    }
    function numericId(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    }
    function todoAnnotationWritable(item) {
      const writable = item?.todoAnnotationWritable ?? item?.todoAnnotationCanWrite ?? item?.canAddTodoAnnotation ?? item?.currentTodoSnapshot?.todoAnnotationWritable ?? item?.todoSnapshot?.todoAnnotationWritable;
      return Boolean(writable);
    }
    async function openCarryoverCandidateAnnotations(candidate) {
      const annotations = normalizeCollection(candidate?.annotations || candidate?.todoAnnotations || candidate?.recentAnnotations);
      if (!hasCarryoverCandidateAnnotations(candidate) || !annotations.length) {
        ElMessage.info('暂无可查看的批注');
        return;
      }
      todoAnnotationWorkItem.value = {
        id: candidate.sourceWorkItemId,
        todoId: candidate.todoId,
        title: candidate.title || candidate.todoSnapshot?.title || '',
        todoSnapshot: candidate.todoSnapshot,
        annotations,
        todoAnnotationPreloaded: true,
        todoAnnotationWritable: false
      };
      todoAnnotationContent.value = '';
      showTodoAnnotationModal.value = true;
      await loadTodoAnnotations();
    }
    async function openTodoAnnotations(item) {
      if (!item?.id || !item?.todoId) {
        ElMessage.info('保存计划后可查看并新增待办批注');
        return;
      }
      todoAnnotationWorkItem.value = item;
      todoAnnotationContent.value = '';
      showTodoAnnotationModal.value = true;
      await loadTodoAnnotations();
    }
    async function loadTodoAnnotations() {
      const item = todoAnnotationWorkItem.value;
      if (!report.value?.id || !item?.id) return;
      if (item.todoAnnotationPreloaded) {
        const annotations = normalizeCollection(item.annotations || item.todoAnnotations);
        todoAnnotations.value = annotations;
        syncWorkItemAnnotationSummary(item, annotations);
        return;
      }
      todoAnnotationLoading.value = true;
      todoAnnotationError.value = false;
      try {
        const result = await listWorkItemTodoAnnotations(report.value.id, item.id);
        todoAnnotations.value = normalizeCollection(result);
        syncWorkItemAnnotationSummary(item, todoAnnotations.value);
      } catch {
        todoAnnotationError.value = true;
        ElMessage.error('待办批注加载失败，请重试');
      } finally {
        todoAnnotationLoading.value = false;
      }
    }
    function closeTodoAnnotationModal() {
      showTodoAnnotationModal.value = false;
      todoAnnotationLoading.value = false;
      todoAnnotationSubmitting.value = false;
      todoAnnotationError.value = false;
      todoAnnotationWorkItem.value = null;
      todoAnnotations.value = [];
      todoAnnotationContent.value = '';
    }
    async function submitTodoAnnotation() {
      const content = todoAnnotationContent.value.trim();
      const item = todoAnnotationWorkItem.value;
      if (!content || !report.value?.id || !item?.id) return;
      todoAnnotationSubmitting.value = true;
      try {
        await addWorkItemTodoAnnotation(report.value.id, item.id, {
          content
        });
        todoAnnotationContent.value = '';
        ElMessage.success('批注已同步');
        await loadTodoAnnotations();
      } catch {
        ElMessage.error('批注提交失败，请重试');
      } finally {
        todoAnnotationSubmitting.value = false;
      }
    }
    function openExportDialog() {
      const baseDate = reportDate.value || localDate();
      exportRange.value = {
        startDate: baseDate,
        endDate: baseDate
      };
      showExportModal.value = true;
    }
    function closeExportDialog() {
      if (exporting.value) return;
      showExportModal.value = false;
    }
    function localDateBefore(daysAgo) {
      const now = new Date();
      now.setDate(now.getDate() - daysAgo);
      const offset = now.getTimezoneOffset();
      return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 10);
    }
    function applyExportPreset(preset) {
      if (exporting.value) return;
      exportRange.value = {
        startDate: localDateBefore(preset.days),
        endDate: localDateBefore(0)
      };
    }
    function isExportPresetActive(preset) {
      return exportRange.value.endDate === localDateBefore(0) && exportRange.value.startDate === localDateBefore(preset.days);
    }
    async function handleExportMyReports() {
      if (exporting.value) return;
      const {
        startDate,
        endDate
      } = exportRange.value;
      if (!startDate || !endDate) {
        ElMessage.warning('请先选择导出的开始与结束日期');
        return;
      }
      if (startDate > endDate) {
        ElMessage.warning('导出开始日期不能晚于结束日期');
        return;
      }
      if (exportRangeDays.value > MAX_EXPORT_RANGE_DAYS) {
        ElMessage.warning(`导出日期区间不能超过 ${MAX_EXPORT_RANGE_DAYS} 天，请缩小范围`);
        return;
      }
      exporting.value = true;
      try {
        const {
          blob,
          fileName
        } = await exportSelfWorkReports({
          startDate,
          endDate
        });
        downloadBlob(blob, fileName);
        showExportModal.value = false;
        ElMessage.success('导出成功');
      } catch (error) {
        ElMessage.error(await resolveBlobErrorMessage(error, '导出失败，请稍后重试'));
      } finally {
        exporting.value = false;
      }
    }
    async function openReminderSetting() {
      reminderSettingVisible.value = true;
      reminderSettingLoading.value = true;
      try {
        reminderSetting.value = await getSelfWorkReportReminderSetting();
      } catch {
        ElMessage.error('提醒设置加载失败，请稍后重试');
      } finally {
        reminderSettingLoading.value = false;
      }
    }
    async function submitReminderSetting(payload) {
      reminderSettingSaving.value = true;
      try {
        const saved = await saveSelfWorkReportReminderSetting(payload);
        reminderSetting.value = saved || payload;
        reminderSettingVisible.value = false;
        ElMessage.success('提醒设置已保存');
      } catch {
        ElMessage.error('提醒设置保存失败，请稍后重试');
      } finally {
        reminderSettingSaving.value = false;
      }
    }
    function openFeedbackModal() {
      if (!report.value?.id) return;
      feedbackFocusCommentId.value = '';
      feedbackFocusTarget.value = '';
      showFeedbackModal.value = true;
    }
    function closeFeedbackModal() {
      showFeedbackModal.value = false;
    }
    function applyFeedbackRouteQuery() {
      feedbackFocusCommentId.value = normalizeRouteId(route.query.commentId);
      feedbackFocusTarget.value = isTruthyRouteFlag(route.query.evaluation) ? 'evaluation' : feedbackFocusCommentId.value ? 'comments' : '';
      if (isTruthyRouteFlag(route.query.feedback) && report.value?.id) {
        showFeedbackModal.value = true;
      }
    }

    /**
     * Pull the latest optimistic-lock version into the in-memory report so a draft save
     * can retry after a version conflict. Returns false (give up self-healing, prompt reload)
     * when the report disappeared or its plan/summary status advanced elsewhere.
     * @returns {Promise<boolean>} True when it is safe to retry with the refreshed version.
     */
    async function resyncReportVersion() {
      if (!report.value?.id) return false;
      try {
        const latest = await getDailyWorkReport(reportDate.value);
        if (!report.value || !latest || latest.id !== report.value.id) return false;
        if (latest.planStatus !== report.value.planStatus || latest.summaryStatus !== report.value.summaryStatus) {
          return false;
        }
        report.value.optimisticVersion = latest.optimisticVersion;
        return true;
      } catch {
        return false;
      }
    }
    async function refreshReportFeedback() {
      if (!report.value?.id) return;
      const updated = await getDailyWorkReport(reportDate.value);
      if (!report.value || updated?.id !== report.value.id) return;
      report.value.comments = Array.isArray(updated?.comments) ? updated.comments : [];
      report.value.evaluations = Array.isArray(updated?.evaluations) ? updated.evaluations : [];
      report.value.statusSummary = updated?.statusSummary || report.value.statusSummary;
      // 同步最新乐观锁版本，避免评论后继续编辑草稿时携带过期版本号
      if (updated?.optimisticVersion !== undefined && updated?.optimisticVersion !== null) {
        report.value.optimisticVersion = updated.optimisticVersion;
      }
    }
    function validatePlan() {
      const itemErrors = {};
      workItems.value.forEach(item => {
        const errors = {};
        const planItemError = planWorkItemError(item);
        if (planItemError) errors.todayGoal = planItemError;
        if (Object.keys(errors).length) itemErrors[itemKey(item)] = errors;
      });
      planItemErrors.value = itemErrors;
      if (Object.keys(itemErrors).length) {
        ElMessage.warning('计划只能从待办或未完成待办计划中选择');
        return false;
      }
      if (!hasReportablePlanItem.value) {
        ElMessage.warning('请至少选择一个待办作为今日计划');
        return false;
      }
      if (report.value.planStatus === 'SUBMITTED' && !adjustmentReason.value.trim()) {
        ElMessage.warning('已提交计划调整时必须填写调整原因');
        return false;
      }
      return true;
    }
    function validateSummary() {
      const invalidResult = workItems.value.find(item => requiresSummaryResult(item) && !item.result);
      if (invalidResult) {
        ElMessage.warning('计划外工作必须填写执行结果');
        return false;
      }
      if (summarySupplementMode.value && !supplementReason.value.trim()) {
        ElMessage.warning('补充总结时必须填写补充原因');
        return false;
      }
      return true;
    }
    function requiresSummaryResult(item) {
      return item.source === 'UNPLANNED' || item.source === 'CARRYOVER' && !item.todoId;
    }
    function isReportablePlanItem(item) {
      return Boolean(item?.todoId || item.source === 'TODO');
    }
    function isValidPlanWorkItem(item) {
      if (!isPlanWorkItemStructurallyValid(item)) return false;
      if (item.id) return true;
      return isPlanTodoReportable(item);
    }
    function planWorkItemError(item) {
      if (!isPlanWorkItemStructurallyValid(item)) return '计划项必须来自可汇报待办';
      if (!item.id && !isPlanTodoReportable(item)) return '新增待办已完成或取消，请刷新后重新选择';
      return '';
    }
    function isPlanWorkItemStructurallyValid(item) {
      if (item.source === 'TODO') return Boolean(item.todoId);
      if (item.source === 'CARRYOVER') return Boolean(item.todoId && item.carryoverFromWorkItemId);
      return false;
    }
    function isPlanTodoReportable(item) {
      const status = item?.currentTodoSnapshot?.status ?? item?.todoSnapshot?.status ?? item?.status;
      const code = normalizeTodoStatusCode(status);
      return code === null || code === 0 || code === 2 || code === 4;
    }
    function handlePlanSubmitRecipientUsersConfirm(users) {
      handlePlanSubmitRecipientUsersChange(selectorUserIds(users));
    }
    function handlePlanSubmitRecipientUsersChange(value) {
      planSubmitRecipientUsers.value = selectorUserIds(value);
    }
    function handlePlanSubmitCcUsersConfirm(users) {
      handlePlanSubmitCcUsersChange(selectorUserIds(users));
    }
    function handlePlanSubmitCcUsersChange(value) {
      planSubmitCcUsers.value = selectorUserIds(value);
    }
    function syncPlanSubmitRecipients(recipients) {
      const values = Array.isArray(recipients) ? recipients : [];
      const usedIds = new Set(fixedRecipientUserIds.value.map(String));
      planSubmitRecipientUsers.value = recipientUserIdsForRole(values, 'RECIPIENT', usedIds);
      planSubmitCcUsers.value = recipientUserIdsForRole(values, 'CC', usedIds);
    }
    function syncPlanSubmitRecipientsFromReport(sourceReport) {
      syncPlanSubmitRecipients(sourceReport?.recipients);
    }
    function recipientUserIdsForRole(recipients, role, usedIds) {
      const result = [];
      for (const recipient of recipients) {
        if (recipient?.role !== role) continue;
        const id = selectorUserId(recipient);
        const key = id == null ? '' : String(id);
        if (!key || usedIds.has(key)) continue;
        usedIds.add(key);
        result.push(id);
      }
      return result;
    }
    function buildEditableRecipientsPayload(recipientUserIds = planSubmitRecipientUsers.value, ccUserIds = planSubmitCcUsers.value) {
      const fixedIds = new Set(fixedRecipientUserIds.value.map(String));
      const usedIds = new Set(fixedIds);
      return [...recipientPayloadFromUserIds(recipientUserIds, 'RECIPIENT', usedIds), ...recipientPayloadFromUserIds(ccUserIds, 'CC', usedIds)];
    }
    function recipientPayloadFromUserIds(userIds, role, usedIds) {
      const payload = [];
      for (const id of selectorUserIds(userIds)) {
        const key = String(id);
        if (!id || usedIds.has(key)) continue;
        usedIds.add(key);
        payload.push({
          userId: Number(id),
          role,
          active: true
        });
      }
      return payload;
    }
    function isEditableReportRecipient(recipient) {
      return recipient?.role === 'RECIPIENT' || recipient?.role === 'CC';
    }
    function selectorUserIds(value) {
      const values = Array.isArray(value) ? value : value ? [value] : [];
      const usedIds = new Set();
      const result = [];
      for (const item of values) {
        const id = selectorUserId(item);
        if (!id || usedIds.has(String(id))) continue;
        usedIds.add(String(id));
        result.push(id);
      }
      return result;
    }
    function selectorUserId(value) {
      if (value && typeof value === 'object') return value.id ?? value.userId;
      return value;
    }
    function buildPlanPayload(extra = {}) {
      return {
        reportId: report.value.id,
        workItems: serializeWorkItems({
          forPlan: true
        }),
        focus: report.value.planFocus || '',
        collaborationNeed: report.value.planCollaborationNeed || '',
        supplement: report.value.planSupplement || '',
        adjustmentReason: adjustmentReason.value || '',
        attachmentObjectKeys: attachmentObjectKeys(),
        ...extra
      };
    }
    function buildSummaryPayload(extra = {}) {
      return {
        reportId: report.value.id,
        workItems: serializeWorkItems(),
        achievement: report.value.summaryAchievement || '',
        blocker: report.value.summaryBlocker || '',
        assistanceNeeded: report.value.summaryAssistanceNeeded || '',
        supplement: report.value.summarySupplement || '',
        supplementReason: supplementReason.value || '',
        attachmentObjectKeys: attachmentObjectKeys(),
        ...extra
      };
    }
    function serializeWorkItems({
      forPlan = false
    } = {}) {
      const items = forPlan ? workItems.value.filter(isValidPlanWorkItem) : workItems.value;
      return items.map(item => normalizeWorkItemForPayload(item, {
        forPlan
      }));
    }
    function normalizeWorkItemForPayload(item, {
      forPlan = false
    } = {}) {
      const payload = {
        ...item
      };
      delete payload.clientKey;
      delete payload.progressPercent;
      delete payload.blocker;
      delete payload.expectedOutcome;
      delete payload.actualOutcome;
      delete payload.annotations;
      delete payload.todoAnnotations;
      delete payload.todoLatestAnnotationContent;
      delete payload.todoLatestAnnotationTime;
      delete payload.todoLatestAnnotationCreatorName;
      delete payload.latestTodoAnnotationContent;
      delete payload.latestTodoAnnotationTime;
      delete payload.latestTodoAnnotationCreatorName;
      const todoSnapshot = normalizeReportTodoSnapshot(payload.todoSnapshot);
      if (todoSnapshot) payload.todoSnapshot = todoSnapshot;
      const currentTodoSnapshot = normalizeReportTodoSnapshot(payload.currentTodoSnapshot);
      if (currentTodoSnapshot) payload.currentTodoSnapshot = currentTodoSnapshot;
      if (!forPlan) {
        payload.result = normalizeSummaryWorkItemResult(payload.result);
      }
      return payload;
    }
    function defaultSummaryWorkItemResult() {
      return 'IN_PROGRESS';
    }
    function normalizeSummaryWorkItemResult(result) {
      return result === 'COMPLETED' ? 'COMPLETED' : defaultSummaryWorkItemResult();
    }
    function attachmentObjectKeys() {
      return attachments.value.map(attachment => attachment.objectKey).filter(Boolean);
    }
    async function flushAllDrafts() {
      if (planSubmittedEditDirty.value || summarySubmittedEditDirty.value) {
        ElMessage.warning('已提交日报的调整或补充请直接提交，不能保存草稿');
        throw new Error('submitted work report edit cannot be saved as a draft');
      }
      await planDraft.flush();
      await summaryDraft.flush();
    }
    function discardAllDrafts() {
      planDraft.discard();
      summaryDraft.discard();
      discardSubmittedEdit('plan');
      discardSubmittedEdit('summary');
    }
    function beginPlanAdjustment() {
      if (!canAdjustPlan.value) {
        ElMessage.warning('总结已提交后，计划调整不可用');
        return;
      }
      if (!canStartPlanAdjustment.value) {
        ElMessage.warning('请先保存或放弃总结草稿');
        return;
      }
      planDraft.discard();
      clearSubmittedEditDirty('plan');
      planAdjustmentMode.value = true;
    }
    function beginSummarySupplement() {
      summaryDraft.discard();
      clearSubmittedEditDirty('summary');
      summarySupplementMode.value = true;
    }
    function markSubmittedEditDirty(phase) {
      submittedEditState.markDirty(phase);
      syncSubmittedEditDirty();
    }
    function clearSubmittedEditDirty(phase) {
      submittedEditState.submitSucceeded(phase);
      syncSubmittedEditDirty();
    }
    function discardSubmittedEdit(phase) {
      submittedEditState.discard(phase);
      syncSubmittedEditDirty();
    }
    function resetSubmittedEditDirty() {
      submittedEditState.reset();
      syncSubmittedEditDirty();
    }
    function syncSubmittedEditDirty() {
      const state = submittedEditState.getState();
      planSubmittedEditDirty.value = state.planSubmittedEditDirty;
      summarySubmittedEditDirty.value = state.summarySubmittedEditDirty;
    }
    function itemKey(item) {
      return String(item?.id ?? item?.clientKey ?? item?.todoId ?? '');
    }
    function clearPlanItemError(item) {
      const key = itemKey(item);
      if (!key || !planItemErrors.value[key]) return;
      const nextErrors = {
        ...planItemErrors.value
      };
      delete nextErrors[key];
      planItemErrors.value = nextErrors;
    }
    function requestUnsavedChoice() {
      showUnsavedModal.value = true;
      return new Promise(resolve => {
        unsavedChoiceResolver = resolve;
      });
    }
    function resolveUnsavedChoice(choice) {
      showUnsavedModal.value = false;
      unsavedChoiceResolver?.(choice);
      unsavedChoiceResolver = null;
    }
    function normalizeReportPhaseQuery(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return text === 'summary' ? 'summary' : 'plan';
    }
    function normalizeReportDateQuery(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return /^\d{4}-\d{2}-\d{2}$/.test(String(text || '')) ? text : '';
    }
    function normalizeRouteId(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return text === null || text === undefined || text === '' ? '' : String(text);
    }
    function isTruthyRouteFlag(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return text === true || text === '1' || text === 'true';
    }
    function reportSupplementRequested(value) {
      return Boolean(value?.statusSummary?.supplementRequested || value?.supplementRequested || value?.summaryStatus === 'PENDING_SUPPLEMENT');
    }
    function isReportDateAfterToday(value) {
      const date = normalizeReportDateQuery(value);
      return Boolean(date && date > localDate());
    }
    function localDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(ReportHeader, {
          report: report.value,
          "report-date": reportDate.value,
          "active-phase": activePhase.value,
          "save-status": activeDraftStatus.value,
          "onUpdate:reportDate": changeReportDate
        }, null, 8, ["report", "report-date", "active-phase", "save-status"])])]),
        default: _withCtx(() => [loading.value ? (_openBlock(), _createElementBlock("section", _hoisted_2, [...(_cache[25] || (_cache[25] = [_createElementVNode("div", {
          class: "app-spinner"
        }, null, -1), _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "正在加载日报...", -1)]))])) : loadError.value ? (_openBlock(), _createElementBlock("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(ExclamationTriangleIcon), {
          class: "h-6 w-6 text-rose-500"
        })]), _cache[26] || (_cache[26] = _createElementVNode("p", {
          class: "text-sm text-slate-600"
        }, "日报加载失败，请稍后重试。", -1)), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary mt-1",
          onClick: _cache[0] || (_cache[0] = $event => loadReport(reportDate.value))
        }, "重试")])) : !report.value ? (_openBlock(), _createElementBlock("section", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(DocumentTextIcon), {
          class: "h-6 w-6 text-slate-400"
        })]), _cache[27] || (_cache[27] = _createElementVNode("p", {
          class: "text-sm text-slate-600"
        }, "当前日期没有可用日报。", -1)), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary mt-1",
          onClick: _cache[1] || (_cache[1] = $event => loadReport(reportDate.value))
        }, "重试")])) : isIneligible.value ? (_openBlock(), _createElementBlock("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_unref(ShieldCheckIcon), {
          class: "h-5 w-5 text-violet-600"
        })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_createVNode(ReportStatusBadge, {
          status: report.value.eligibilityStatus
        }, null, 8, ["status"]), _cache[28] || (_cache[28] = _createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "当前日报无需填写", -1))])])]), _createElementVNode("p", _hoisted_11, _toDisplayString(report.value.exemptionReason || report.value.statusConfirmationReason || '暂无补充说明。'), 1), eligibilitySource.value ? (_openBlock(), _createElementBlock("p", _hoisted_12, "来源：" + _toDisplayString(eligibilitySource.value), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("section", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(ReportStageTabs, {
          modelValue: activePhase.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => activePhase.value = $event)
        }, null, 8, ["modelValue"]), isFutureReportDate.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 未到日期不能填写、保存或提交日报内容。 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_createElementVNode("p", _hoisted_18, _toDisplayString(activePhase.value === 'summary' ? summaryDescription.value : '填写今天的工作安排。'), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary inline-flex items-center gap-1.5",
          title: "导出我的日报",
          onClick: openExportDialog
        }, [_createVNode(_unref(ArrowDownTrayIcon), {
          class: "h-4 w-4"
        }), _cache[29] || (_cache[29] = _createElementVNode("span", null, "导出日报", -1))]), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary inline-flex items-center gap-1.5",
          title: "提醒设置",
          "aria-label": "提醒设置",
          onClick: openReminderSetting
        }, [_createVNode(_unref(BellIcon), {
          class: "h-4 w-4"
        }), _cache[30] || (_cache[30] = _createElementVNode("span", null, "提醒设置", -1))]), report.value?.id ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn-secondary inline-flex items-center gap-1.5",
          title: "评价与反馈",
          "aria-label": "评价与反馈",
          onClick: openFeedbackModal
        }, [_createVNode(_unref(ChatBubbleLeftRightIcon), {
          class: "h-4 w-4"
        }), _createElementVNode("span", null, _toDisplayString(feedbackButtonLabel.value), 1), feedbackBadgeLabel.value ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(feedbackBadgeLabel.value), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activePhase.value === 'plan' && canAdjustPlan.value && !planAdjustmentMode.value ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "btn-secondary",
          disabled: !canStartPlanAdjustment.value,
          onClick: beginPlanAdjustment
        }, "调整计划", 8, _hoisted_21)) : _createCommentVNode("", true), activePhase.value === 'plan' && canAdjustPlan.value && !canStartPlanAdjustment.value && !planAdjustmentMode.value ? (_openBlock(), _createElementBlock("p", _hoisted_22, "请先保存或放弃总结草稿")) : activePhase.value === 'plan' && report.value.planStatus === 'SUBMITTED' && report.value.summaryStatus === 'SUBMITTED' ? (_openBlock(), _createElementBlock("p", _hoisted_23, "总结已提交后，计划调整不可用。")) : _createCommentVNode("", true), activePhase.value === 'summary' && report.value.summaryStatus === 'SUBMITTED' && !summarySupplementMode.value ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          type: "button",
          class: "btn-secondary",
          onClick: beginSummarySupplement
        }, "补充总结")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_24, [activePhase.value === 'plan' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [planEditable.value || displayedCarryoverCandidates.value.length || planEditOptionsLoading.value ? (_openBlock(), _createElementBlock("section", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[31] || (_cache[31] = _createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "未完成计划候选", -1)), carryoverCandidateTotalCount.value ? (_openBlock(), _createElementBlock("span", _hoisted_29, " 已选 " + _toDisplayString(selectedCarryoverCandidateCount.value) + " / 共 " + _toDisplayString(carryoverCandidateTotalCount.value), 1)) : _createCommentVNode("", true)]), _cache[32] || (_cache[32] = _createElementVNode("p", {
          class: "mt-0.5 text-sm text-slate-500"
        }, "默认勾选历史未完成待办，可取消不需要带入的计划。", -1))]), planEditable.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn-secondary inline-flex shrink-0 items-center justify-center gap-1.5",
          disabled: planEditOptionsLoading.value || selectedCarryoverCandidateCount.value === 0,
          onClick: addSelectedCarryoverCandidates
        }, [_createVNode(_unref(PlusIcon), {
          class: "h-4 w-4"
        }), _createTextVNode(_toDisplayString(planEditOptionsLoading.value ? '加载中' : '加入当前计划'), 1)], 8, _hoisted_30)) : _createCommentVNode("", true)]), planEditOptionsLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[33] || (_cache[33] = [_createElementVNode("div", {
          class: "app-spinner is-xs"
        }, null, -1), _createTextVNode(" 正在加载候选计划... ", -1)]))])) : !displayedCarryoverCandidates.value.length ? (_openBlock(), _createElementBlock("p", _hoisted_32, [_createVNode(_unref(InformationCircleIcon), {
          class: "h-4 w-4"
        }), _cache[34] || (_cache[34] = _createTextVNode("暂无可带入的未完成计划。 ", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedCarryoverCandidates.value, candidate => {
          return _openBlock(), _createElementBlock("label", {
            key: candidate.candidateKey,
            class: _normalizeClass(["carryover-candidate-row flex cursor-pointer items-start gap-3 px-3 py-2.5 transition-colors duration-150 hover:bg-slate-50", {
              'cursor-default opacity-70': !planEditable.value
            }])
          }, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectedCarryoverCandidateKeys.value = $event),
            class: "form-check mt-0.5 h-4 w-4 shrink-0",
            type: "checkbox",
            value: candidate.candidateKey,
            disabled: !planEditable.value
          }, null, 8, _hoisted_34), [[_vModelCheckbox, selectedCarryoverCandidateKeys.value]]), _createElementVNode("span", _hoisted_35, [_createElementVNode("span", _hoisted_36, [_createElementVNode("span", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(candidate.title || candidate.todoSnapshot?.title || '--'), 1), _createElementVNode("span", _hoisted_39, [candidate.reportDate ? (_openBlock(), _createElementBlock("span", _hoisted_40, "来源 " + _toDisplayString(candidate.reportDate), 1)) : _createCommentVNode("", true), candidate.expectedFinishAt ? (_openBlock(), _createElementBlock("span", _hoisted_41, "预计 " + _toDisplayString(_unref(formatDateTimeText)(candidate.expectedFinishAt)), 1)) : _createCommentVNode("", true), hasCarryoverCandidateAnnotations(candidate) ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "rounded bg-violet-50 px-1.5 text-violet-600 transition-colors hover:bg-violet-100 hover:text-violet-700",
            title: "查看批注",
            onClick: _withModifiers($event => openCarryoverCandidateAnnotations(candidate), ["stop", "prevent"])
          }, " 批注 " + _toDisplayString(candidate.annotationCount), 9, _hoisted_42)) : _createCommentVNode("", true)])]), _cache[35] || (_cache[35] = _createElementVNode("span", {
            class: "shrink-0 rounded-full status-badge is-success px-2 py-0.5 text-[11px] font-medium ring-1 ring-emerald-100"
          }, "待加入", -1))]), candidate.expectedOutcome ? (_openBlock(), _createElementBlock("span", _hoisted_43, "预期：" + _toDisplayString(candidate.expectedOutcome), 1)) : _createCommentVNode("", true)])], 2);
        }), 128))]))])) : _createCommentVNode("", true), _createElementVNode("section", null, [_createElementVNode("div", _hoisted_44, [_cache[37] || (_cache[37] = _createElementVNode("div", null, [_createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "工作项"), _createElementVNode("p", {
          class: "mt-0.5 text-sm text-slate-500"
        }, "计划只能从待办选择，未完成的待办计划可从上方候选带入。")], -1)), planEditable.value ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary inline-flex items-center gap-1.5",
          onClick: _cache[4] || (_cache[4] = $event => showTodoPicker.value = true)
        }, [_createVNode(_unref(ClipboardDocumentListIcon), {
          class: "h-4 w-4"
        }), _cache[36] || (_cache[36] = _createTextVNode("从待办添加", -1))])])) : _createCommentVNode("", true)]), workItems.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_unref(ClipboardDocumentListIcon), {
          class: "h-8 w-8 text-slate-300"
        }), _cache[38] || (_cache[38] = _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无工作项，请从待办添加或加入未完成计划候选。", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_47, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workItems.value, (item, index) => {
          return _openBlock(), _createBlock(ReportWorkItemEditor, {
            key: item.id || item.clientKey,
            item: item,
            errors: planItemErrors.value[itemKey(item)],
            "annotation-count": workItemAnnotationCount(item),
            phase: "plan",
            readonly: !planEditable.value,
            "onUpdate:item": $event => updateWorkItem(index, $event),
            onRemove: $event => requestRemoveWorkItem(index),
            onOpenAnnotations: $event => openTodoAnnotations(item)
          }, null, 8, ["item", "errors", "annotation-count", "readonly", "onUpdate:item", "onRemove", "onOpenAnnotations"]);
        }), 128))]))]), _createElementVNode("section", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-4 w-4 text-blue-600"
        })]), _cache[39] || (_cache[39] = _createElementVNode("h2", {
          class: "text-sm font-semibold text-slate-800"
        }, "计划概要", -1))]), _createElementVNode("div", _hoisted_51, [_createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-blue-300 focus-within:ring-2 focus-within:ring-blue-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !planEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_52, [_createVNode(_unref(StarIcon), {
          class: "h-3.5 w-3.5 text-amber-500"
        }), _cache[40] || (_cache[40] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "今日重点", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => report.value.planFocus = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !planEditable.value,
          placeholder: "请输入今日重点",
          onInput: markPlanDirty
        }, null, 40, _hoisted_53), [[_vModelText, report.value.planFocus]])], 2), _createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-blue-300 focus-within:ring-2 focus-within:ring-blue-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !planEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_54, [_createVNode(_unref(UserGroupIcon), {
          class: "h-3.5 w-3.5 text-blue-500"
        }), _cache[41] || (_cache[41] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "需要协同", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => report.value.planCollaborationNeed = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !planEditable.value,
          placeholder: "请输入需要协同的事项",
          onInput: markPlanDirty
        }, null, 40, _hoisted_55), [[_vModelText, report.value.planCollaborationNeed]])], 2), _createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-blue-300 focus-within:ring-2 focus-within:ring-blue-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !planEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_56, [_createVNode(_unref(InformationCircleIcon), {
          class: "h-3.5 w-3.5 text-slate-400"
        }), _cache[42] || (_cache[42] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "补充说明", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => report.value.planSupplement = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !planEditable.value,
          placeholder: "请输入补充说明",
          onInput: markPlanDirty
        }, null, 40, _hoisted_57), [[_vModelText, report.value.planSupplement]])], 2), planAdjustmentMode.value ? (_openBlock(), _createElementBlock("label", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-3.5 w-3.5 text-amber-600"
        }), _cache[43] || (_cache[43] = _createElementVNode("span", {
          class: "text-xs font-semibold text-amber-800"
        }, [_createTextVNode("调整原因"), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => adjustmentReason.value = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-amber-400 focus:outline-none",
          rows: "2",
          placeholder: "请说明调整原因",
          onInput: markPlanDirty
        }, null, 544), [[_vModelText, adjustmentReason.value]])])) : _createCommentVNode("", true)])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("section", null, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", null, [_cache[44] || (_cache[44] = _createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "工作项", -1)), _cache[45] || (_cache[45] = _createElementVNode("p", {
          class: "mt-0.5 text-sm text-slate-500"
        }, "填写计划工作项的执行结果。", -1)), summaryBlockedReason.value ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(summaryBlockedReason.value), 1)) : _createCommentVNode("", true)])]), workItems.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createVNode(_unref(ClipboardDocumentListIcon), {
          class: "h-8 w-8 text-slate-300"
        }), _cache[46] || (_cache[46] = _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无工作项，可直接填写总结。", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_63, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workItems.value, (item, index) => {
          return _openBlock(), _createBlock(ReportWorkItemEditor, {
            key: item.id || item.clientKey,
            item: item,
            "annotation-count": workItemAnnotationCount(item),
            phase: "summary",
            readonly: !summaryEditable.value,
            "onUpdate:item": $event => updateWorkItem(index, $event),
            onRemove: $event => requestRemoveWorkItem(index),
            onOpenAnnotations: $event => openTodoAnnotations(item)
          }, null, 8, ["item", "annotation-count", "readonly", "onUpdate:item", "onRemove", "onOpenAnnotations"]);
        }), 128))]))]), _createElementVNode("section", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createVNode(_unref(ClipboardDocumentCheckIcon), {
          class: "h-4 w-4 text-emerald-600"
        })]), _cache[47] || (_cache[47] = _createElementVNode("h2", {
          class: "text-sm font-semibold text-slate-800"
        }, "总结概要", -1))]), _createElementVNode("div", _hoisted_67, [_createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-emerald-300 focus-within:ring-2 focus-within:ring-emerald-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !summaryEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_68, [_createVNode(_unref(CheckBadgeIcon), {
          class: "h-3.5 w-3.5 text-emerald-500"
        }), _cache[48] || (_cache[48] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "今日成果", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => report.value.summaryAchievement = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !summaryEditable.value,
          placeholder: "请输入今日成果",
          onInput: markSummaryDirty
        }, null, 40, _hoisted_69), [[_vModelText, report.value.summaryAchievement]])], 2), _createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-red-300 focus-within:ring-2 focus-within:ring-red-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !summaryEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_70, [_createVNode(_unref(ExclamationTriangleIcon), {
          class: "h-3.5 w-3.5 text-red-400"
        }), _cache[49] || (_cache[49] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "阻塞事项", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => report.value.summaryBlocker = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !summaryEditable.value,
          placeholder: "请输入阻塞事项",
          onInput: markSummaryDirty
        }, null, 40, _hoisted_71), [[_vModelText, report.value.summaryBlocker]])], 2), _createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-violet-300 focus-within:ring-2 focus-within:ring-violet-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !summaryEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_72, [_createVNode(_unref(HandRaisedIcon), {
          class: "h-3.5 w-3.5 text-violet-500"
        }), _cache[50] || (_cache[50] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "需要协助", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => report.value.summaryAssistanceNeeded = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !summaryEditable.value,
          placeholder: "请输入需要协助的事项",
          onInput: markSummaryDirty
        }, null, 40, _hoisted_73), [[_vModelText, report.value.summaryAssistanceNeeded]])], 2), _createElementVNode("label", {
          class: _normalizeClass(["group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 cursor-text focus-within:border-slate-400 focus-within:ring-2 focus-within:ring-slate-100 hover:border-slate-300", {
            'opacity-60 pointer-events-none': !summaryEditable.value
          }])
        }, [_createElementVNode("div", _hoisted_74, [_createVNode(_unref(InformationCircleIcon), {
          class: "h-3.5 w-3.5 text-slate-400"
        }), _cache[51] || (_cache[51] = _createElementVNode("span", {
          class: "text-xs font-semibold text-slate-600"
        }, "补充说明", -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => report.value.summarySupplement = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
          rows: "2",
          readonly: !summaryEditable.value,
          placeholder: "请输入补充说明",
          onInput: markSummaryDirty
        }, null, 40, _hoisted_75), [[_vModelText, report.value.summarySupplement]])], 2), summarySupplementMode.value ? (_openBlock(), _createElementBlock("label", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-3.5 w-3.5 text-amber-600"
        }), _cache[52] || (_cache[52] = _createElementVNode("span", {
          class: "text-xs font-semibold text-amber-800"
        }, [_createTextVNode("补充原因"), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1))]), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => supplementReason.value = $event),
          class: "flex-1 resize-none border-0 bg-transparent px-3 py-2 text-sm text-slate-700 placeholder:text-amber-400 focus:outline-none",
          rows: "2",
          placeholder: "请说明补充原因",
          onInput: markSummaryDirty
        }, null, 544), [[_vModelText, supplementReason.value]])])) : _createCommentVNode("", true)])])], 64)), _createVNode(ReportAttachmentList, {
          "report-id": report.value.id,
          attachments: attachments.value,
          readonly: !activeEditable.value,
          "max-count": report.value.attachmentMaxCount || 20,
          "max-size-mb": attachmentMaxSizeMb.value,
          "allowed-media-types": report.value.attachmentAllowedMediaTypes,
          "allowed-extensions": report.value.attachmentAllowedExtensions,
          "onUpdate:attachments": updateAttachments
        }, null, 8, ["report-id", "attachments", "readonly", "max-count", "max-size-mb", "allowed-media-types", "allowed-extensions"])])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [activeDraftStatus.value === 'saving' ? (_openBlock(), _createElementBlock("span", _hoisted_80, "自动保存中...")) : _createCommentVNode("", true), activeDraftStatus.value === 'error' ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "btn-secondary",
          disabled: submitting.value,
          onClick: retryActiveDraft
        }, "重试保存", 8, _hoisted_81)) : _createCommentVNode("", true), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: submitting.value || !activeEditable.value || isSubmittedPhaseEdit.value || activePhase.value === 'summary' && !canSaveSummary.value,
          onClick: saveActiveDraft
        }, "保存草稿", 8, _hoisted_82), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: submitting.value || recipientPreferencesLoading.value || !activeEditable.value || activePhase.value === 'summary' && !canSubmitSummary.value,
          onClick: submitActivePhase
        }, _toDisplayString(recipientPreferencesLoading.value ? '加载中' : submitting.value ? '提交中' : activePhase.value === 'plan' ? '提交计划' : '提交总结'), 9, _hoisted_83)])])])), _createVNode(TodoPickerDrawer, {
          modelValue: showTodoPicker.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => showTodoPicker.value = $event),
          "selected-todo-ids": selectedTodoIds.value,
          onConfirm: addTodos
        }, null, 8, ["modelValue", "selected-todo-ids"]), _createVNode(WorkReportReminderSettingModal, {
          modelValue: reminderSettingVisible.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => reminderSettingVisible.value = $event),
          setting: reminderSetting.value,
          loading: reminderSettingLoading.value,
          saving: reminderSettingSaving.value,
          onSubmit: submitReminderSetting
        }, null, 8, ["modelValue", "setting", "loading", "saving"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showExportModal.value,
          size: "sm",
          "z-index": 70,
          scrollable: false,
          onClose: closeExportDialog
        }, {
          default: _withCtx(() => [_createElementVNode("header", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("span", _hoisted_87, [_createVNode(_unref(ArrowDownTrayIcon), {
            class: "h-5 w-5"
          })]), _cache[53] || (_cache[53] = _createElementVNode("h2", {
            class: "text-base font-semibold text-slate-900"
          }, "导出我的日报", -1))]), _createElementVNode("p", {
            class: "mt-1.5 text-sm leading-6 text-slate-500"
          }, " 按日期区间导出本人日报为 xlsx（含工作项明细与批注），区间最长 " + _toDisplayString(MAX_EXPORT_RANGE_DAYS) + " 天。 ")]), _createElementVNode("button", {
            type: "button",
            class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
            title: "关闭",
            "aria-label": "关闭",
            disabled: exporting.value,
            onClick: closeExportDialog
          }, [_createVNode(_unref(XMarkIcon), {
            class: "h-5 w-5"
          })], 8, _hoisted_88)]), _createElementVNode("div", _hoisted_89, [_createElementVNode("section", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_cache[54] || (_cache[54] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "日期区间", -1)), _createElementVNode("div", _hoisted_92, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(EXPORT_RANGE_PRESETS, preset => {
            return _createElementVNode("button", {
              key: preset.label,
              type: "button",
              class: _normalizeClass(["rounded-full px-2.5 py-1 text-xs font-medium transition-colors", isExportPresetActive(preset) ? 'bg-blue-600 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200']),
              disabled: exporting.value,
              onClick: $event => applyExportPreset(preset)
            }, _toDisplayString(preset.label), 11, _hoisted_93);
          }), 64))])]), _createElementVNode("div", _hoisted_94, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => exportRange.value.startDate = $event),
            class: "form-input form-control-sm w-full",
            type: "date",
            "aria-label": "导出开始日期",
            max: exportRange.value.endDate || undefined,
            disabled: exporting.value
          }, null, 8, _hoisted_95), [[_vModelText, exportRange.value.startDate]]), _cache[55] || (_cache[55] = _createElementVNode("span", {
            class: "shrink-0 text-xs text-slate-400"
          }, "至", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => exportRange.value.endDate = $event),
            class: "form-input form-control-sm w-full",
            type: "date",
            "aria-label": "导出结束日期",
            min: exportRange.value.startDate || undefined,
            disabled: exporting.value
          }, null, 8, _hoisted_96), [[_vModelText, exportRange.value.endDate]])])])]), _createElementVNode("footer", _hoisted_97, [_createElementVNode("span", _hoisted_98, _toDisplayString(exportSummaryText.value), 1), _createElementVNode("div", _hoisted_99, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: exporting.value,
            onClick: closeExportDialog
          }, "取消", 8, _hoisted_100), _createElementVNode("button", {
            type: "button",
            class: "btn-primary inline-flex items-center gap-1.5",
            disabled: exporting.value,
            onClick: handleExportMyReports
          }, [_createVNode(_unref(ArrowDownTrayIcon), {
            class: "h-4 w-4"
          }), _createTextVNode(" " + _toDisplayString(exporting.value ? '导出中...' : '导出 xlsx'), 1)], 8, _hoisted_101)])])]),
          _: 1
        }, 8, ["visible"])])), pendingRemoveItem.value ? (_openBlock(), _createBlock(DeleteConfirmModal, {
          key: 5,
          title: "确定要删除该工作项吗？",
          message: pendingRemoveMessage.value,
          onClose: cancelRemoveWorkItem,
          onConfirm: confirmRemoveWorkItem
        }, null, 8, ["message"])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showUnsavedModal.value,
          size: "sm",
          "z-index": 70,
          scrollable: false,
          onClose: _cache[21] || (_cache[21] = $event => resolveUnsavedChoice('continue'))
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createVNode(_unref(ExclamationTriangleIcon), {
            class: "h-6 w-6 text-amber-600"
          })]), _cache[56] || (_cache[56] = _createElementVNode("h2", {
            class: "mt-3 text-base font-semibold text-slate-900"
          }, "存在未保存修改", -1)), _cache[57] || (_cache[57] = _createElementVNode("p", {
            class: "mt-2 text-sm leading-6 text-slate-500"
          }, "离开前可先保存草稿，也可以放弃本次未保存修改。", -1))]), _createElementVNode("div", _hoisted_104, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[18] || (_cache[18] = $event => resolveUnsavedChoice('continue'))
          }, "继续编辑"), _createElementVNode("button", {
            type: "button",
            class: "btn-danger-secondary",
            onClick: _cache[19] || (_cache[19] = $event => resolveUnsavedChoice('discard'))
          }, "放弃"), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: _cache[20] || (_cache[20] = $event => resolveUnsavedChoice('save'))
          }, "保存草稿")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showPlanSubmitRecipientsModal.value,
          size: "2xl",
          "z-index": 70,
          scrollable: false,
          onClose: cancelPlanSubmission
        }, {
          default: _withCtx(() => [_cache[61] || (_cache[61] = _createElementVNode("div", {
            class: "border-b border-slate-100 px-5 pb-4 pt-5"
          }, [_createElementVNode("h2", {
            class: "text-base font-semibold text-slate-900"
          }, "设置报送对象"), _createElementVNode("p", {
            class: "mt-1 text-sm leading-6 text-slate-500"
          }, "确认本次计划提交的额外接收人与抄送人，固定接收对象由后端规则自动带入。")], -1)), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_cache[58] || (_cache[58] = _createElementVNode("div", {
            class: "text-xs font-semibold text-slate-500"
          }, "固定接收", -1)), fixedReportRecipients.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_107, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedReportRecipients.value, recipient => {
            return _openBlock(), _createElementBlock("span", {
              key: `submit-fixed-${recipient.userId}`,
              class: "inline-flex min-w-0 max-w-full items-center rounded-md bg-white px-2 py-1 text-xs text-slate-600 ring-1 ring-slate-200"
            }, [_createElementVNode("span", _hoisted_108, _toDisplayString(recipient.userNameSnapshot || recipient.userName || recipient.name || `用户 ${recipient.userId}`), 1)]);
          }), 128))])) : (_openBlock(), _createElementBlock("p", _hoisted_109, "暂无固定接收对象"))]), _createElementVNode("div", _hoisted_110, [_createElementVNode("label", _hoisted_111, [_cache[59] || (_cache[59] = _createElementVNode("span", {
            class: "form-label"
          }, "额外接收人", -1)), _createVNode(UserSelector, {
            modelValue: planSubmitRecipientUsers.value,
            "onUpdate:modelValue": [_cache[22] || (_cache[22] = $event => planSubmitRecipientUsers.value = $event), handlePlanSubmitRecipientUsersChange],
            class: "mt-1",
            multiple: true,
            disabled: submitting.value || !recipientEditable.value,
            "exclude-ids": planSubmitRecipientExcludeIds.value,
            placeholder: "请选择额外接收人",
            onConfirm: handlePlanSubmitRecipientUsersConfirm
          }, null, 8, ["modelValue", "disabled", "exclude-ids"])]), _createElementVNode("label", _hoisted_112, [_cache[60] || (_cache[60] = _createElementVNode("span", {
            class: "form-label"
          }, "抄送人", -1)), _createVNode(UserSelector, {
            modelValue: planSubmitCcUsers.value,
            "onUpdate:modelValue": [_cache[23] || (_cache[23] = $event => planSubmitCcUsers.value = $event), handlePlanSubmitCcUsersChange],
            class: "mt-1",
            multiple: true,
            disabled: submitting.value || !recipientEditable.value,
            "exclude-ids": planSubmitCcExcludeIds.value,
            placeholder: "请选择抄送人",
            onConfirm: handlePlanSubmitCcUsersConfirm
          }, null, 8, ["modelValue", "disabled", "exclude-ids"])])])]), _createElementVNode("div", _hoisted_113, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: submitting.value,
            onClick: cancelPlanSubmission
          }, "取消", 8, _hoisted_114), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: submitting.value || !recipientEditable.value,
            onClick: confirmPlanSubmission
          }, _toDisplayString(submitting.value ? '提交中' : '确认提交计划'), 9, _hoisted_115)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showFeedbackModal.value,
          size: "3xl",
          "panel-class": "max-h-[86vh]",
          "z-index": 70,
          scrollable: false,
          onClose: closeFeedbackModal
        }, {
          default: _withCtx(() => [_createElementVNode("header", _hoisted_116, [_createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_cache[62] || (_cache[62] = _createElementVNode("h2", {
            class: "text-base font-semibold text-slate-900"
          }, "评价与反馈", -1)), feedbackBadgeLabel.value ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(feedbackBadgeLabel.value), 1)) : _createCommentVNode("", true)]), _cache[63] || (_cache[63] = _createElementVNode("p", {
            class: "mt-1 text-sm leading-6 text-slate-500"
          }, "查看接收人对这份日报的评价、评论与补充要求。", -1))]), _createElementVNode("button", {
            type: "button",
            class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
            title: "关闭反馈",
            "aria-label": "关闭反馈",
            onClick: closeFeedbackModal
          }, [_createVNode(_unref(XMarkIcon), {
            class: "h-5 w-5"
          })])]), _createElementVNode("div", _hoisted_120, [_createVNode(ReportFeedbackSection, {
            report: report.value,
            embedded: true,
            "can-comment": Boolean(report.value?.id),
            submitting: feedbackSubmitting.value,
            "focus-comment-id": feedbackFocusCommentId.value,
            "focus-target": feedbackFocusTarget.value,
            onComment: submitSelfComment
          }, null, 8, ["report", "can-comment", "submitting", "focus-comment-id", "focus-target"])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showTodoAnnotationModal.value,
          size: "2xl",
          "panel-class": "max-h-[82vh]",
          "z-index": 70,
          scrollable: false,
          onClose: closeTodoAnnotationModal
        }, {
          default: _withCtx(() => [_createElementVNode("header", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_cache[64] || (_cache[64] = _createElementVNode("h2", {
            class: "text-base font-semibold text-slate-900"
          }, "待办批注", -1)), _createElementVNode("p", _hoisted_123, _toDisplayString(todoAnnotationWorkItem.value?.title || todoAnnotationWorkItem.value?.todoSnapshot?.title || '--'), 1)]), _createElementVNode("button", {
            type: "button",
            class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
            title: "关闭",
            "aria-label": "关闭",
            onClick: closeTodoAnnotationModal
          }, [_createVNode(_unref(XMarkIcon), {
            class: "h-5 w-5"
          })])]), _createElementVNode("main", _hoisted_124, [todoAnnotationLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_125, [...(_cache[65] || (_cache[65] = [_createElementVNode("div", {
            class: "app-spinner is-sm"
          }, null, -1), _createTextVNode(" 正在加载批注... ", -1)]))])) : todoAnnotationError.value ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_createVNode(_unref(ExclamationTriangleIcon), {
            class: "h-8 w-8 text-rose-400"
          }), _cache[66] || (_cache[66] = _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "批注加载失败，请重试。", -1)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: loadTodoAnnotations
          }, "重试")])) : !todoAnnotations.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_127, " 暂无批注 ")) : (_openBlock(), _createElementBlock("div", _hoisted_128, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todoAnnotations.value, annotation => {
            return _openBlock(), _createElementBlock("div", {
              key: annotation.id || annotation.createTime || annotation.content,
              class: "rounded-lg border border-slate-100 bg-slate-50/70 px-3.5 py-3"
            }, [_createElementVNode("div", _hoisted_129, [_createElementVNode("span", _hoisted_130, _toDisplayString(annotation.creatorName || annotation.createByName || annotation.authorName || '未知用户'), 1), _createElementVNode("span", null, _toDisplayString(annotation.createTime || annotation.createdAt || ''), 1)]), _createElementVNode("p", _hoisted_131, _toDisplayString(annotation.content || annotation.remark || '--'), 1)]);
          }), 128))]))]), canAddTodoAnnotation.value ? (_openBlock(), _createElementBlock("footer", _hoisted_132, [_createElementVNode("label", _hoisted_133, [_cache[67] || (_cache[67] = _createElementVNode("span", {
            class: "form-label"
          }, "新增批注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => todoAnnotationContent.value = $event),
            class: "form-textarea form-control-sm mt-1 w-full",
            rows: "3",
            maxlength: "1000",
            placeholder: "请输入批注内容"
          }, null, 512), [[_vModelText, todoAnnotationContent.value]])]), _createElementVNode("div", _hoisted_134, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: todoAnnotationSubmitting.value,
            onClick: closeTodoAnnotationModal
          }, "取消", 8, _hoisted_135), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: todoAnnotationSubmitting.value || !todoAnnotationContent.value.trim(),
            onClick: submitTodoAnnotation
          }, _toDisplayString(todoAnnotationSubmitting.value ? '提交中' : '提交批注'), 9, _hoisted_136)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};